import { useEffect, useState } from "react";
import { uploadIcon } from "../../components/images";
import { MDBIcon } from "mdb-react-ui-kit";
import UIConstant from "../../apiclients/UIConstant";
import SaveChanges from "../../components/topviews/saveCancel";
import { downloadBrandProofDoc } from "../../apiclients/streamsapi_bridge";

const CampaignProofDocuments = ({
  uploadedExistFiles,
  campStatus,
  campaignid,
  setIsloading,
  onSave,    // (newFiles, deletedIds) => void
  onCancel,  // () => void
}) => {
  const [uploadedOldFiles, setUploadedOldFiles] = useState([]);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [deletedIds, setDeletedIds] = useState([]);

  useEffect(() => {
    if (uploadedExistFiles && uploadedExistFiles.length > 0) {
      setUploadedOldFiles(uploadedExistFiles);
    } else {
      setUploadedOldFiles([]);
    }
  }, [uploadedExistFiles]);

  // Upload/delete is allowed only when status is " CNP Declined"
  const canEdit = campStatus === "CNP Declined";

  const hasChanges = uploadedFiles.length > 0 || deletedIds.length > 0;

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const existingNames = [
      ...uploadedOldFiles.map((f) => f.file_name),
      ...uploadedFiles.map((f) => f.name),
    ];

    const validFiles = files.filter((file) => {
      if (file.type !== "application/pdf") {
        alert("Only PDF files are allowed");
        return false;
      }
      if (file.size > UIConstant.max_brand_proof_pdfsize * 1024 * 1024) {
        alert(
          `File size must be less than ${UIConstant.max_brand_proof_pdfsize} MB`
        );
        return false;
      }
      if (existingNames.includes(file.name)) {
        alert(`File "${file.name}" is already uploaded`);
        return false;
      }
      return true;
    });

    const totalFilesCount =
      uploadedOldFiles.length + uploadedFiles.length + validFiles.length;

    if (totalFilesCount > UIConstant.max_brand_proof_pdfcount) {
      alert(
        `Maximum of ${UIConstant.max_brand_proof_pdfcount} files can be uploaded in total`
      );
      return;
    }

    const newFiles = validFiles.map((file) => ({
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2) + " MB",
      file: file,
    }));

    setUploadedFiles((prev) => [...prev, ...newFiles]);
    e.target.value = "";
  };

  const handleDeleteFile = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeleteOldFile = (index, fileid) => {
    setUploadedOldFiles((prev) => prev.filter((_, i) => i !== index));
    setDeletedIds((prev) => [...prev, fileid]);
    console.log("Campaign: Deleted old proof doc with ID:", fileid);
  };

  const handleDownloadOldFile = async (fileInfo) => {
    try {
      if (setIsloading) setIsloading(true);
      const apiResponse = await downloadBrandProofDoc(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        campaignid,
        fileInfo.id,
        1
      );
      if (setIsloading) setIsloading(false);
      if (apiResponse.status === 200) {
        const fileUrl = URL.createObjectURL(await apiResponse.blob());
        const a = document.createElement("a");
        a.href = fileUrl;
        a.download = fileInfo.file_name;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(fileUrl);
      } else {
        alert("Failed to download file. Please try again.");
      }
    } catch (error) {
      console.log("Error downloading file:", error);
      if (setIsloading) setIsloading(false);
      alert("Error downloading file. Please try again.");
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (onSave) {
      const success = await onSave(uploadedFiles, deletedIds);
      if (success) {
        setUploadedFiles([]);
        setDeletedIds([]);
      }
    }
  };

  const handleCancel = () => {
    // Reset local state and notify parent
    setUploadedFiles([]);
    setDeletedIds([]);
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <>
      <div className="general-settings">Proof of Documents</div>

      {/* Upload section — visible only when status is " CNP Declined" */}
      {canEdit && (
        <div
          className="uploadOuter mt-3 w-100 sm-w-100 my-3"
          style={{ paddingLeft: "10px" }}
        >
          <span className="dragBox2 upload-content sm-w-100">
            <span>
              <img src={uploadIcon} className="upload-img" alt="Upload Icon" />
            </span>
            <span>Drag and Drop to upload Files</span>
            <small className="text-secondary mt-2">
              Maximum of {UIConstant.max_brand_proof_pdfcount} PDF files (Max
              file size: {UIConstant.max_brand_proof_pdfsize} MB) can be
              uploaded!
            </small>
            <input
              type="file"
              id="campaignUploadFile"
              className="upload__img LOA"
              onChange={handleFileChange}
              multiple
              accept=".pdf"
            />
          </span>
        </div>
      )}

      <h6 style={{ paddingLeft: "10px" }}>Uploaded Documents</h6>
      <div className="listOfFiles pt-0">
        {/* Existing files from API — always visible */}
        {uploadedOldFiles && uploadedOldFiles.length > 0 && (
          <div className="d-flex align-items-center justify-content-center flex-column">
            {uploadedOldFiles.map((fileinfo, index) => (
              <div
                key={fileinfo.id}
                className="border p-2 px-3 mt-2 rounded bg-light w-100 d-flex align-items-center justify-content-between"
              >
                <span>{fileinfo.file_name}</span>
                <div className="d-flex align-items-center gap-3">
                  <MDBIcon
                    fas
                    icon="download"
                    size="lg"
                    className="cursor-pointer text-primary"
                    title="Download"
                    onClick={() => handleDownloadOldFile(fileinfo)}
                  />
                  {canEdit && (
                    <div style={{ width: "24px" }}>
                      <MDBIcon
                        fas
                        icon="trash-alt"
                        className="cursor-pointer text-danger"
                        size="lg"
                        title="Remove"
                        onClick={() => handleDeleteOldFile(index, fileinfo.id)}
                      />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Newly added files — visible only when canEdit */}
        {uploadedFiles.length > 0 && (
          <div className="d-flex align-items-center justify-content-center flex-column">
            {uploadedFiles.map((fileinfo, index) => (
              <div
                key={index}
                className="border p-2 px-3 mt-2 rounded bg-light w-100 d-flex align-items-center justify-content-between"
              >
                <span className="d-block">{fileinfo.name}</span>
                <div className="d-flex align-items-center gap-3">
                  <div style={{ width: "24px" }}>
                    <MDBIcon
                      fas
                      icon="trash-alt"
                      size="lg"
                      className="cursor-pointer text-danger"
                      title="Remove"
                      onClick={() => handleDeleteFile(index)}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Save bar — visible only when canEdit and there are pending changes */}
      {canEdit && hasChanges && (
        <SaveChanges
          onClose={handleCancel}
          isdirtyFields={true}
          onSave={handleSave}
        />
      )}
    </>
  );
};

export default CampaignProofDocuments;
